import STORE_CONST from '../consts'
import reviewApi from '../../api/review'

const state = {
}

const mutations = {
}

const actions = {
  // get project id
  [STORE_CONST.REVIEW.GET_PROJECT_LIST] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      reviewApi.getProject(params).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // get resource list
  [STORE_CONST.REVIEW.GET_RESOURCE_LIST] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      reviewApi.getResourceList(params).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  [STORE_CONST.REVIEW.CREATE_SQL_APPLICATION] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      reviewApi.createSqlApplication(params).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  [STORE_CONST.REVIEW.GET_MY_SQL_APPLICATION] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      reviewApi.getMySqlApplication(params).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  [STORE_CONST.REVIEW.GET_SQL_APPROVING_APPLICATION] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      reviewApi.getApprovingApplication(params).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  [STORE_CONST.REVIEW.GET_SQL_APPROVED_APPLICATION] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      reviewApi.getApprovedApplication(params).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  [STORE_CONST.REVIEW.GET_SAFE_APPLICATION] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      reviewApi.getSafeApplication(params).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  [STORE_CONST.REVIEW.CREATE_SAFE_APPLY] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      reviewApi.createSafeModeApply(params).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  [STORE_CONST.REVIEW.GET_MY_SAFE_APPLY] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      reviewApi.getMySafeModeApply(params).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  [STORE_CONST.REVIEW.GET_SAFE_APPROVING_APPLY] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      reviewApi.getSafeApprovingApply(params).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  [STORE_CONST.REVIEW.GET_SAFE_APPROVED_APPLY] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      reviewApi.getSafeApprovedApply(params).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  [STORE_CONST.REVIEW.GET_MY_APPLY_DETAIL] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      reviewApi.getMyApplyDetail(params).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  [STORE_CONST.REVIEW.DELETE_SQL_APPLY] ({ commit }, id) {
    return new Promise((resolve, reject) => {
      reviewApi.deleteSqlDetail(id).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  [STORE_CONST.REVIEW.EXECUTE_SQL_APPLICATION] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      reviewApi.excuteSqlApplication(params).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  [STORE_CONST.REVIEW.REJECT_SQL_APPLICATION] ({ commit }, id) {
    const params = {
      status: 'rejected'
    }
    return new Promise((resolve, reject) => {
      reviewApi.rejectSqlApplication(params, id).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  [STORE_CONST.REVIEW.GET_SAFE_DETAIL] ({ commit }, id) {
    return new Promise((resolve, reject) => {
      reviewApi.getSafeDetail(id).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  [STORE_CONST.REVIEW.DELETE_SAFE_APPLY] ({ commit }, id) {
    return new Promise((resolve, reject) => {
      reviewApi.deleteSafeApply(id).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  [STORE_CONST.REVIEW.DO_SAFE_EXCUTE] ({ commit }, id) {
    const params = {
      app_status: 1
    }
    return new Promise((resolve, reject) => {
      reviewApi.doSafeExcute(params, id).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  [STORE_CONST.REVIEW.DO_SAFE_REJECT] ({ commit }, id) {
    const params = {
      app_status: 2
    }
    return new Promise((resolve, reject) => {
      reviewApi.doSafeReject(params, id).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  }

}

const getters = {
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/review.js